"use strict";

var _classCallCheck = require("C:\\ProgsVS2017\\fanals\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\ProgsVS2017\\fanals\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DropTargetImpl =
/*#__PURE__*/
function () {
  _createClass(DropTargetImpl, [{
    key: "canDrop",
    value: function canDrop() {
      var spec = this.spec;
      var monitor = this.monitor;
      return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
  }, {
    key: "hover",
    value: function hover() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.hover) {
        spec.hover(monitor.getItem(), monitor);
      }
    }
  }, {
    key: "drop",
    value: function drop() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.drop) {
        return spec.drop(monitor.getItem(), monitor);
      }

      return;
    }
  }]);

  function DropTargetImpl(spec, monitor) {
    _classCallCheck(this, DropTargetImpl);

    this.spec = spec;
    this.monitor = monitor;
  }

  return DropTargetImpl;
}();

exports.DropTargetImpl = DropTargetImpl;